import { CommunityInvite } from '../../models/inviteService.model';
import useSelectedCommunity from './useSelectedCommunity';

export default function useCommunityInvite(): CommunityInvite | undefined {
  return useSelectedCommunity()?.inviteFields;
}
